<template>
  <div>
    <div class="details-banner" v-if="!bannerImg"></div>
    <a :href="!!bannerPath && bannerPath">
      <img :src="bannerImg" style="width: 100%;margin-top: 64px" v-if='sourceType === "img" && bannerImg' />
      <video id="" autoplay muted loop preload="auto" style="z-index: 200; width: 100%; height: auto;;margin-top: 64px"
        v-if='sourceType === "video" && video'>
        <source type="video/mp4" :src="video" />
      </video>
    </a>
    <div v-if="!active" class="about-container">
      <div class="about-head">
        <el-row>
          <el-col :xs="8" :md="3" :lg="2">
            <span class="about-head-title" :class="{ active: active == 0 }" @click="active = 0">平台介绍</span>
          </el-col>
          <el-col :xs="8" :md="3" :lg="2">
            <span class="about-head-title" :class="{ active: active == 1 }" @click="active = 1">公司介绍</span>
          </el-col>
        </el-row>
      </div>
      <div class="about-contant" v-for="v in detail" :key="v.id">
        <div v-for="item in v.contentList" :key="item.id" v-if="v.moduleName === '自定义模块'">
          <div class="about-contant-title" v-if='item.type === "title"'>
            <span></span>
            <span>{{ item.title }}</span>
          </div>
          <div class="text" v-if='item.type === "introduction"' v-html="item.introduction"></div>
          <div style="margin-top: 50px;width: 100%;" class="img" v-if='item.type === "picture"'>
            <img :src="item.picture" style="width: 100%" />
          </div>
        </div>
        <div v-if="v.moduleName === '事件模块'">
          <div class="about-contant-title">
            <span></span>
            <span>{{ v.moduleTitle }}</span>
          </div>
          <el-row :gutter="50">
            <el-col v-for="item in v.contentList" :key="item.id" :xs="24" :md="8" style="margin-bottom: 15px">
              <el-card :body-style="{ padding: '0px', cursor: 'default' }" shadow="hover">
                <img :src="item.picture" style="width: 100%;height: 250px" />
                <div style="padding: 20px;">
                  <div class="card-text-title">{{ item.title.slice(0, 10) }}</div>
                  <div class="card-text-desc">{{ item.introduction }}</div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
      </div>

    </div>

    <div v-else class="about-container">
      <div class="about-head">
        <el-row>
          <el-col :xs="8" :md="3" :lg="2">
            <span class="about-head-title" :class="{ active: active == 0 }" @click="active = 0">平台介绍</span>
          </el-col>
          <el-col :xs="8" :md="3" :lg="2">
            <span class="about-head-title" :class="{ active: active == 1 }" @click="active = 1">公司介绍</span>
          </el-col>
        </el-row>
      </div>
      <div class="about-contant" v-for="v in detail" :key="v.id">
        <div v-for="item in v.contentList" :key="item.id" v-if="v.moduleName === '自定义模块'">
          <div class="about-contant-title" v-if='item.type === "title"'>
            <span></span>
            <span>{{ item.title }}</span>
          </div>
          <div class="text" v-if='item.type === "introduction"'>{{ item.introduction }}</div>
          <div style="margin-top: 50px;width: 100%;" class="img" v-if='item.type === "picture"'>
            <img :src="item.picture" style="width: 100%" />
          </div>
        </div>
        <div v-if="v.moduleName === '成果模块'">
          <div class="about-contant-title">
            <span></span>
            <span>{{ v.moduleTitle }}</span>
          </div>
          <el-row :gutter="50">
            <el-col v-for="item in v.contentList" :key="item.id" :xs="24" :md="8" style="margin-bottom: 15px">
              <el-card :body-style="{ padding: '0px', cursor: 'default' }" shadow="hover">
                <img :src="item.picture" style="width: 100%;height: 250px" />
                <div style="padding: 20px;">
                  <div class="card-text-desc">{{ item.introduction }}</div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { platformDetail, componyDetail, listBanner } from '@/api'
export default {
  name: "AboutUs",
  data () {
    return {
      active: 0,
      detail: [],
      sourceType: 'img',
      bannerImg: '',
      video: '',
      bannerPath: ''
    }
  },
  created () {
    // 获取数据
    this.getData()
    // 获取banner数据
    this.getBanner()
  },
  watch: {
    active (newVal) {
      this.getData()
    }
  },
  methods: {
    async getBanner () {
      const res = await listBanner({ bannerPosition: 'GYWM_BANNER' })

      const data = res.rows.find(v => (v.bannerImg && v.sourceType == 'img') || (v.video && v.sourceType == 'video'))
      if (!data) return
      this.sourceType = data.sourceType
      this.bannerImg = data.bannerImg
      this.video = data.video
      this.bannerPath = data.link
    },
    async getData () {
      this.detail = []
      if (this.active === 0) { //平台介绍
        const res = await platformDetail()
        this.detail = res.rows
      } else { //公司介绍
        const res = await componyDetail()
        this.detail = res.rows
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.about-container {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  min-height: 340px;
  padding-bottom: 50px;

  .img {
    width: 100%;
    margin-top: 25px;
    margin-bottom: 25px;
  }

  .about-head {
    width: 75%;
    margin-top: 50px;

    .about-head-title {
      font-size: 18px;
      font-weight: 500;
      color: #333333;
      cursor: pointer;
    }

    .active {
      color: #E50009;
    }
  }

  .about-contant {
    width: 75%;
    /* margin-bottom: 50px; */

    .culture-card {
      box-shadow: 0rem 0.04rem 0.3rem 0rem rgba(204, 204, 204, 0.7);
      margin-bottom: 40px;
    }

    .text {
      font-size: 16px;
      font-weight: 500;
      color: rgba(19, 20, 21, 0.70);
      line-height: 32px;
    }

    .about-contant-title {
      height: 45px;
      margin: 50px 0;
      font-weight: 500;
      color: #000000;

      :first-child {
        display: inline-block;
        width: 3px;
        height: 20px;
        background: #E50009;
        margin-right: 5px;
      }

      span {
        font-size: 32px;
      }
    }


    .card-text-title {
      font-size: 16px;
      font-weight: 600;
      color: #131415;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .card-text-desc {
      height: 65px;
      font-size: 16px;
      font-weight: 400;
      color: rgba(19, 20, 21, 0.70);
      margin-top: 15px;
      word-break: break-all;
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }

    .card-text-icon {
      margin-left: 10px;
      margin-bottom: 10px;
      color: #E50009;
      cursor: default;
    }

  }
}
</style>


// WEBPACK FOOTER //
// src/components/AboutUs.vue